import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=28fdda2c&scoped=true"
import script from "./tag.vue?vue&type=script&lang=ts"
export * from "./tag.vue?vue&type=script&lang=ts"
import style0 from "./tag.vue?vue&type=style&index=0&id=28fdda2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fdda2c",
  null
  
)

export default component.exports